import React, { useState, useCallback, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// =========================
// MAP THEMES
// =========================
const mapThemes = {
  light: {
    name: 'Light',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; OpenStreetMap contributors',
  },

  dark: {
    name: 'Dark',
        url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?key=cb1_2rc9_1_eb8768f9990879c647613f76",
    attribution: '&copy; CARTO',
  },
};


// =========================
// LOCATIONS
// =========================
const locations = {
  'Pakuwon Tower': {
    lat: -7.2610202,
    lng: 112.7384933,
    zoom: 18,
  },

  'Ponorogo': {
    lat: -7.8715679,
    lng: 111.4630003,
    zoom: 12,
  },

  'East Java': {
    lat: -6.9074277,
    lng: 110.9408088,
    zoom: 7,
  },

  'Indonesia': {
    lat: -0.8249566,
    lng: 114.6713572,
    zoom: 4,
  },
};


// =========================
// MARKER
// =========================
const Red_MARKER = `data:image/svg+xml;utf8,${encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg"
       width="81"
       height="81"
       viewBox="0 0 81 81"
       fill="none">

    <circle
      cx="40.7252"
      cy="40.1992"
      r="40"
      fill="#38c206"
      fill-opacity="0.12"
    />

    <circle
      cx="40.7252"
      cy="40.2006"
      r="26.5599"
      fill="#38c206"
      fill-opacity="0.24"
    />

    <circle
      cx="40.7252"
      cy="40.1992"
      r="17.1367"
      fill="#38c206"
    />

  </svg>
`)}`;

const BoatIcon = L.icon({
  iconUrl: Red_MARKER,
  iconSize: [40, 40],
  iconAnchor: [20, 20],
  popupAnchor: [0, -20],
});


// =========================
// MAP VIEW
// =========================
const MapView = ({ position, zoom }) => {
  const map = useMap();

  useEffect(() => {
    map.flyTo(
      [position.lat, position.lng],
      zoom,
      {
        duration: 1.25,
        animate: true,
      }
    );
  }, [position, zoom, map]);

  return null;
};


// =========================
// THEME DETECTOR
// =========================
const useDarkMode = () => {
  const [isDark, setIsDark] = useState(() => {
    return document.documentElement.classList.contains('dark');
  });

  useEffect(() => {
    const html = document.documentElement;

    const observer = new MutationObserver(() => {
      setIsDark(html.classList.contains('dark'));
    });

    observer.observe(html, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  return isDark;
};


// =========================
// MAIN COMPONENT
// =========================
export default function Domiciline() {

  const [currentLocation, setCurrentLocation] = useState(
    locations['Ponorogo']
  );

  const isDark = useDarkMode();

  const handleHover = useCallback((location) => {
    setCurrentLocation(locations[location]);
  }, []);

  const currentTheme = isDark
    ? mapThemes.dark
    : mapThemes.light;


  // =========================
  // CLOCK
  // =========================
  const [time, setTime] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();

      const options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Asia/Jakarta',
      };

      const formatter = new Intl.DateTimeFormat(
        'en-US',
        options
      );

      setTime(formatter.format(now));
    }, 1000);

    return () => clearInterval(interval);
  }, []);


  return (
    <section className="flex flex-col gap-2">

      <div className="h-[300px] rounded overflow-hidden">

        <MapContainer
          center={[
            currentLocation.lat,
            currentLocation.lng,
          ]}
          zoom={currentLocation.zoom}
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '20px',
          }}
        >

          {/* =========================
              BASE MAP
          ========================= */}
          <TileLayer
            key={isDark ? 'dark' : 'light'}
            url={currentTheme.url}
            attribution={currentTheme.attribution}
          />


          {/* =========================
              FLY TO LOCATION
          ========================= */}
          <MapView
            position={{
              lat: currentLocation.lat,
              lng: currentLocation.lng,
            }}
            zoom={currentLocation.zoom}
          />


          {/* =========================
              MARKER
          ========================= */}
          <Marker
            position={[
              currentLocation.lat,
              currentLocation.lng,
            ]}
            icon={BoatIcon}
          >
            <Popup>
              Lng: {currentLocation.lng}
              <br />
              Lat: {currentLocation.lat}
            </Popup>
          </Marker>

        </MapContainer>

      </div>

    </section>
  );
}